export const use_cases = [
  {
    id: 'personal_portraits',
    label: 'Personal Portraits & Selfies',
    description:
      'For profile photos, selfies, and everyday portraits of yourself.',
    coverImage: 'minimal-aesthetic-portrait.avif',
  },
  {
    id: 'professional_headshots',
    label: 'Professional Headshots & Career',
    description:
      'For LinkedIn, resumes, client work, and polished professional identity.',
    coverImage: 'modern-corporate-portrait.avif',
  },
  {
    id: 'dating_social',
    label: 'Dating & Social Profiles',
    description:
      'For dating apps and social platforms where first impressions matter.',
    coverImage: 'natural-dating-profile.avif',
  },
  {
    id: 'creator_influencer',
    label: 'Creator & Influencer',
    description:
      'For YouTube thumbnails, TikTok, streaming, and personal branding.',
    coverImage: 'creator-studio-portrait.avif',
  },
  {
    id: 'product_ecommerce',
    label: 'Product & E-commerce',
    description:
      'For product shots, catalogs, storefronts, and marketing pages.',
    coverImage: 'ecomm-shine.avif',
  },
  {
    id: 'marketing_creative',
    label: 'Marketing & Advertising Creative',
    description:
      'For campaigns, ads, landing pages, and promotional materials.',
    coverImage: 'flat-vector-social.avif',
  },
  {
    id: 'art_illustration_3d',
    label: 'Art, Illustration & 3D',
    description:
      'For stylized art, anime, 3D characters, and experimental visuals.',
    coverImage: 'pixar-vinyl-render.avif',
  },
  {
    id: 'cinematic_storytelling',
    label: 'Cinematic & Storytelling',
    description: 'For film-inspired frames, key art, and narrative shots.',
    coverImage: 'roger-deakins.avif',
  },
  {
    id: 'family_events',
    label: 'Family, Events & Milestones',
    description:
      'For maternity, family portraits, celebrations, and special occasions.',
    coverImage: 'warm-maternity-portrait.avif',
  },
  {
    id: 'avatars_characters',
    label: 'Avatars, Characters & Personas',
    description:
      'For avatars, VTuber-style looks, digital personas, and character creation.',
    coverImage: 'anime-character-portrait.avif',
  },
  //
  {
    id: 'startup_founder_tech',
    label: 'Startup Founder & Tech Leader',
    description:
      'For pitch decks, investor meetings, startup profiles, and tech leadership branding.',
    coverImage: 'founder-branding-portrait.avif',
  },
  {
    id: 'developer_designer_portfolio',
    label: 'Developer & Designer Portfolio',
    description:
      'For personal websites, portfolio sites, GitHub profiles, and creative professional branding.',
    coverImage: 'author-podcaster-portrait.avif',
  },
  {
    id: 'youtube_channel_branding',
    label: 'YouTube Channel Branding',
    description:
      'For channel art, consistent thumbnails, end screens, and cohesive creator identity.',
    coverImage: 'thumbnail-reaction-shot.avif',
  },
  {
    id: 'tech_conference_speaker',
    label: 'Tech Conference Speaker',
    description:
      'For speaking profiles, conference websites, event bios, and thought leadership presence.',
    coverImage: 'modern-corporate-portrait.avif',
  },
  {
    id: 'saas_product_marketing',
    label: 'SaaS Product Marketing',
    description:
      'For landing pages, product launches, feature announcements, and startup marketing materials.',
    coverImage: 'apple-keynote-product.avif',
  },
  {
    id: 'open_source_advocacy',
    label: 'Open Source & Developer Advocacy',
    description:
      'For GitHub profiles, dev community presence, technical content, and open source project branding.',
    coverImage: 'creator-studio-portrait.avif',
  },
  {
    id: 'podcast_audio_branding',
    label: 'Podcast & Audio Branding',
    description:
      'For podcast covers, show artwork, audio platform profiles, and podcast guest appearances.',
    coverImage: 'author-podcaster-portrait.avif',
  },
  {
    id: 'remote_work_professional',
    label: 'Remote Work Professional',
    description:
      'For virtual meetings, remote team profiles, async communication, and distributed work presence.',
    coverImage: 'clean-profile-avatar.avif',
  },
  {
    id: 'tech_blog_content',
    label: 'Tech Blog & Content Creator',
    description:
      'For blog author photos, newsletter branding, technical writing, and developer content creation.',
    coverImage: 'natural-dating-profile.avif',
  },
  {
    id: 'investor_pitch_materials',
    label: 'Investor Pitch & Startup Materials',
    description:
      'For pitch decks, investor profiles, startup documentation, and fundraising presentation materials.',
    coverImage: 'founder-portrait.avif',
  },
]
